import { Breadcrumb } from "../../../../core/Breadcrumb.js";
import { Text } from "../../../../core/Text.js";
import { ActionButton } from "../../../shared/ActionButton.js";
import type { ForgeHeadingContent } from "../../forgeContent.js";

/** The forge's top: where it sits, its one h1 and what it is, and its actions. */
export function ForgeHeading({ trail, current, title, intro, actions }: ForgeHeadingContent) {
  return (
    <div className="flex flex-col gap-4 md:gap-5">
      <Breadcrumb items={[...trail, { label: current }]} className="max-md:hidden" />
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div className="flex max-w-2xl flex-col gap-2">
          <Text as="h1" variant="display-xl2" tone="primary" className="max-md:text-display-xl3">
            {title}
          </Text>
          <Text variant="body-b1" tone="secondary">
            {intro}
          </Text>
        </div>
        {actions.length > 0 && (
          <div className="flex flex-wrap gap-2 max-md:[&>*]:flex-1">
            {actions.map((action) => (
              <ActionButton
                key={action.label}
                action={action}
                variant={action.emphasis === "primary" ? "primary" : "secondary"}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
